"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocations = exports.combineLocations = void 0;

var _CombineLocations = require("./CombineLocations");

// Initialize the CombineLocations class
var combinedLocations = new _CombineLocations.CombineLocations(); // export the combineLocations method which combined the objects passed in from anywhere

var combineLocations = function combineLocations() {
  return combinedLocations.setCombinedLocations.apply(combinedLocations, arguments);
};

exports.combineLocations = combineLocations;

var getLocations = function getLocations() {
  return combinedLocations.getCombinedLocations();
};

exports.getLocations = getLocations;
//# sourceMappingURL=combine-locations.js.map